module.exports = __webpack_public_path__ + "img/courseChelovek.0f880f31.png";